export const T16 = {
    "columns": 12,
    "rows": 2,
    "visual": {
        "id": 1,
        "type": "advancedTable",
        "colorTheme": "colorTheme1",
        "title": "Product Sales by Customer Group (PESO)",
        "binding": {
            "data": {
                "columns": [
                    {
                        "name": 'Customer Group',
                        "columnName": 'CustomerGroup',
                        "width": '300px',
                        "align": "left",
                        "sortable": true,
                        "sum": false
                    },
                    {
                        "name": 'Actual Sales',
                        "columnName": 'ActualSales(Value)',
                        "width": '140px',
                        "align": "right",
                        "sortable": true,
                        "sum": true
                    },
                    {
                        "name": 'LYSales',
                        "columnName": 'LYSales(Value)',
                        "width": '150px',
                        "align": "right",
                        "sortable": true,
                        "sum": true
                    },
                    {
                        "name": 'Growth %',
                        "columnName": 'Growth(Value)',
                        "width": '150px',
                        "align": "right",
                        "sortable": true,
                        "percent": true
                    }
                ],
                "title": 'CustomerGroup',
                "endpoint": "T16",
                "parameters": [
                    { "key": "FromMonth", "value": "2024" },
                    { "key": "FromYear", "value": "1" },
                    { "key": "ToMonth", "value": "2024" },
                    { "key": "ToYear", "value": "1" },
                    { "key": "AgentCode", "value": "" },
                    { "key": "ConfigTypeCode", "value": "" }
                ]
            },
            "context": {
                "point": {
                    "onClick": {
                        "selectedValueColumn": 'CustomerGroup',
                        "visuals": [
                            {
                                "title": "Product",
                                "visual": [
                                    {
                                        "columns": 12,
                                        "rows": 2,
                                        "visual": {
                                            "id": 1,
                                            "type": "advancedTable",
                                            "colorTheme": "colorTheme1",
                                            "title": "Product",
                                            "binding": {
                                                "data": {
                                                    "columns": [
                                                        {
                                                            "name": 'Item Name',
                                                            "columnName": 'ItemName',
                                                            "width": '150px',
                                                            "align": "left",
                                                            "sortable": true,
                                                            "sum": false
                                                        },
                                                        {
                                                            "name": 'Sales (PESO)',
                                                            "columnName": 'ActualSales(Value)',
                                                            "width": '140px',
                                                            "align": "right",
                                                            "sortable": true,
                                                            "sum": true
                                                        },
                                                        {
                                                            "name": 'LYSales (PESO)',
                                                            "columnName": 'LYSales(Value)',
                                                            "width": '150px',
                                                            "align": "right",
                                                            "sortable": true,
                                                            "sum": true
                                                        },
                                                        {
                                                            "name": '% Growth (PESO)',
                                                            "columnName": 'Growth(Value)',
                                                            "width": '170px',
                                                            "align": "right",
                                                            "sortable": true,
                                                            "sum": false,
                                                            "percent": true
                                                        },
                                                        {
                                                            "name": 'Sales (UNIT)',
                                                            "columnName": 'ActualSales(Qty)',
                                                            "width": '140px',
                                                            "align": "right",
                                                            "sortable": true
                                                        },
                                                        {
                                                            "name": 'LYSales (UNIT)',
                                                            "columnName": 'LYSales(Qty)',
                                                            "width": '150px',
                                                            "align": "right",
                                                            "sortable": true
                                                        },
                                                        {
                                                            "name": '% Growth (UNIT)',
                                                            "columnName": 'Growth(Qty)',
                                                            "width": '170px',
                                                            "align": "right",
                                                            "sortable": true,
                                                            "sum": false,
                                                            "percent": true
                                                        }
                                                    ],
                                                    "title": 'ItemName',
                                                    "endpoint": "T16.2",
                                                    "parameters": [
                                                        { "key": "FromMonth", "value": "2024" },
                                                        { "key": "FromYear", "value": "1" },
                                                        { "key": "ToMonth", "value": "2024" },
                                                        { "key": "ToYear", "value": "1" },
                                                        { "key": "AgentCode", "value": "" },
                                                        { "key": "CustomerGroup", "value": "" },
                                                        { "key": "ConfigTypeCode", "value": "" }
                                                    ]
                                                },
                                                "context": {
                                                    "point": {
                                                        "onClick": {

                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                ]
                            }

                        ]
                    }
                }
            }
        }
    }
}